<template>

  <b-modal id="RolUpdate" size="md" ref="modal" centered no-close-on-backdrop hide-footer>

    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title">Editar Rol</h5>
      <button type="button" aria-label="Close" class="close" @click="close()" :disabled="loading">×</button>
    </template>

    <template slot="default" slot-scope="{ hide }">

      <b-form class="final_form" @submit.stop.prevent="editar" ref="form">

        <div class="final_form_container">

          <div class="final_form_input_group">
              <label class="final_form_group_input_label" for="browser_first_name">Nombre</label>
              <b-form-input class="inputText" v-model="rol.name" type="text" placeholder="" required :disabled="loading"></b-form-input>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" @click="hide()" class="btn btn-secondary" :disabled="loading">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="loading">Guardar</button>
        </div>

      </b-form>

    </template>

  </b-modal>

</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      rol: {},
      loading: false
    }
  },
  methods: {
    setId (id) {
       try {
        if (!localStorage.signedIn) {
          this.$router.push('/')
        } else {
          this.rol.id = id;

          this.loading = true

          this.getRolForUpdate(this.rol.id)
            .then(data => {
              this.rol = data.rol
              this.loading = false
            })
        } 
      } catch (error) {
        this.showError(error)
      }
      
    },
    editar () {
      try {

        this.loading = true

        this.rol.name = this.cs(this.rol.name)

        this.$http.secured.patch(`/auth/v1/roles/${this.rol.id}`, { v2_rol: this.rol })
          .then(response => { 
            
            this.loading = false

            console.log(response)
            this.showOK("Se actualizó el rol correctamente!")
            this.$emit('closeModal')
            this.$refs.modal.hide()
          })
          .catch(error => {
            this.showError(error)
            this.loading = false
          })  
      } catch (error) {
        this.showError(error)
        this.loading = false
      }
    }
  }
}
</script>
